import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";
import type { ResourceContactType } from "shared/types/outreach";

import type OutreachCommunication from "./OutreachCommunication";

@Model()
class OutreachCommunicationContact extends ApplicationRecord {
  static jsonapiType = "outreach_communication_contacts";

  @BelongsTo() contact: ResourceContactType;

  @Attr() contactId: number;

  @Attr() contactType: string;

  @BelongsTo() outreachCommunication: OutreachCommunication;

  @Attr() outreachCommunicationId: number;
}

export default OutreachCommunicationContact;
